// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__q2H9v","Header":"Pricing_Header__iPT1X"};